module.exports = __webpack_public_path__ + "static/media/logo_200.0483e9c0.png";